import { render, staticRenderFns } from "./live.vue?vue&type=template&id=679178d6&scoped=true&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"
import style0 from "./live.vue?vue&type=style&index=0&lang=less&"
import style1 from "./live.vue?vue&type=style&index=1&id=679178d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679178d6",
  null
  
)

export default component.exports